import { buildInstalledBasePathname, DetailTab } from './installedBaseUrl';

export interface NodeDetailTabTarget {
    pathname: string;
    search: string;
}

/**
 * Deep link into the installed base tree with the node detail panel open on
 * `tab`. Targets `sourceNodeId` when it is part of the path (e.g. the ancestor
 * a value is inherited from); otherwise the node itself. `pathNodeIds` are the
 * ancestors root-first — the backend includes the node itself in some
 * resolvers and not in others, so it is appended when missing. The target may
 * be outside the user's read access, in which case the tree simply shows what
 * it may.
 */
export const buildNodeDetailTabUrl = (
    ownNodeId: string | undefined | null,
    pathNodeIds: ReadonlyArray<string | undefined | null>,
    tab: DetailTab,
    sourceNodeId?: string | null,
): NodeDetailTabTarget => {
    const path = pathNodeIds.filter((id): id is string => typeof id === 'string' && id.length > 0);
    if (ownNodeId && path[path.length - 1] !== ownNodeId) path.push(ownNodeId);
    const sourceIndex = sourceNodeId ? path.indexOf(sourceNodeId) : -1;
    const selected = sourceIndex >= 0 ? path.slice(0, sourceIndex + 1) : path;
    return {
        pathname: buildInstalledBasePathname([null, ...selected]),
        search: `?detail=${tab}`,
    };
};
